import { render, staticRenderFns } from "./IconMore.vue?vue&type=template&id=745e0b5e&scoped=true&lang=pug&"
import script from "./IconMore.vue?vue&type=script&lang=js&"
export * from "./IconMore.vue?vue&type=script&lang=js&"
import style0 from "./IconMore.vue?vue&type=style&index=0&id=745e0b5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745e0b5e",
  null
  
)

export default component.exports